import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import FromIdeaToShelf from "./sections/FromIdeaToShelf";
import Services from "./sections/Services";
import OurIndieMission from "./sections/OurIndieMission";
import TheCocktailHour from "./sections/TheCocktailHour";
import GalleriaSommersa from "./sections/GalleriaSommersa";
import LetsSolveProblems from "./sections/LetsSolveProblems";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <FromIdeaToShelf />
      <Services />
      <OurIndieMission />
      <TheCocktailHour />
      <GalleriaSommersa />
      <LetsSolveProblems />
      <Footer />
    </div>;
}